export default {
  XS: 360,
  SM: 578,
  MD: 768,
  LG: 1024,
  XL: 1280,
  XXL: 1440,
  XXXL: 1600,
};
